/**
 * Appends UTM parameters to a URL for tracking outgoing links
 * @param url - The original URL
 * @param source - UTM source (default: 'weddingly')
 * @param medium - UTM medium (default: 'referral')
 * @param campaign - Optional UTM campaign name
 * @returns URL with UTM parameters appended
 */
export function appendUtmParams(
  url: string,
  source: string = 'weddingly',
  medium: string = 'referral',
  campaign?: string
): string {
  if (!url) return url;
  
  try {
    const urlObj = new URL(url);
    urlObj.searchParams.set('utm_source', source);
    urlObj.searchParams.set('utm_medium', medium);
    if (campaign) {
      urlObj.searchParams.set('utm_campaign', campaign);
    }
    return urlObj.toString();
  } catch {
    // If URL parsing fails, return original URL
    return url;
  }
}
